import React, { useContext, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import {
  Typography
} from '@mui/material';
import { AuthContext } from "components/Auth";
import { Layout as DashboardLayout } from 'layouts/portal/layout';
import { getStorage, ref as storage_ref, getDownloadURL } from "firebase/storage";

const storage = getStorage();


export const Help = () => {
  const { currentUser } = useContext(AuthContext);
  const [ url, setURL ] = useState(null);
  useEffect(() => {
    getDownloadURL(storage_ref(storage, 'web_app_help/index.html'))
    .then((url) => {
      setURL(url)
    })
  }, [])

  return (
    <DashboardLayout>
      <hr/>
      { url ? (
        <iframe style={{
          border: "none"
        }} src={url}></iframe>
      ) : null}
    </DashboardLayout>
  );
};
